export const ATHLINK_COMMISSION_RATE = 0.135

export interface PaymentBreakdown {
  grossAmount: number
  commissionRate: number
  commissionAmount: number
  processingFee: number
  netAmount: number
}

export function calculatePaymentBreakdown(grossAmount: number, commissionRate = ATHLINK_COMMISSION_RATE): PaymentBreakdown {
  if (!Number.isFinite(grossAmount) || grossAmount < 0) throw new Error('Le montant doit être positif.')
  const commissionAmount = roundMoney(grossAmount * commissionRate)
  const processingFee = roundMoney(grossAmount * 0.015 + 0.25)
  const netAmount = roundMoney(grossAmount - commissionAmount - processingFee)
  return { grossAmount: roundMoney(grossAmount), commissionRate, commissionAmount, processingFee, netAmount }
}

export function roundMoney(value: number) {
  return Math.round((value + Number.EPSILON) * 100) / 100
}
